module.exports = __webpack_public_path__ + "img/pizzaset-822.4c8752ac.png";